(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elimest-sosyal-kanit"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-kanit]').forEach(function (box) {
        if (box.dataset.eReady) return;
        box.dataset.eReady = '1';
        box.querySelectorAll('[data-e-ago]').forEach(function (li) {
          var m = li.dataset.eAgo.trim().match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})[ T]([0-9]{2}):([0-9]{2})/);
          if (!m) { li.remove(); return; }
          var when = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
          var mins = Math.round((Date.now() - when.getTime()) / 60000);
          if (mins < 0 || mins > 48 * 60) { li.remove(); return; }
          li.textContent = mins < 60 ? li.dataset.templateMin.replace('[dakika]', Math.max(mins, 1)) : li.dataset.template.replace('[saat]', Math.round(mins / 60));
          li.hidden = false;
        });
        box.querySelectorAll('[data-e-expire]').forEach(function (li) {
          var m = li.dataset.eExpire.trim().match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})[ T]([0-9]{2}):([0-9]{2})/);
          var when = m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) : null;
          if (!when || Date.now() - when.getTime() > 24 * 3600000) li.remove();
        });
        if (!box.querySelector('.e-kanit__item.is-active')) { var first = box.querySelector('.e-kanit__item:not([hidden])'); if (first) { first.classList.add('is-active'); first.removeAttribute('aria-hidden'); } }
        var items = box.querySelectorAll('.e-kanit__item');
        if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var i = 0;
        setInterval(function () {
          if (document.hidden) return;
          var cur = items[i];
          i = (i + 1) % items.length;
          var nxt = items[i];
          cur.classList.remove('is-active');
          cur.classList.add('is-out');
          cur.setAttribute('aria-hidden', 'true');
          nxt.classList.remove('is-out');
          nxt.classList.add('is-active');
          nxt.removeAttribute('aria-hidden');
          setTimeout(function () { cur.classList.remove('is-out'); }, 600);
        }, (parseInt(box.dataset.speed, 10) || 4) * 1000);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["elimest-stok"] && !Shopify.designMode) return;
  try {
    (function () {
    function addBusinessDays(date, n) {
      var d = new Date(date);
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n--;
      }
      return d;
    }
    function fmt(d) {
      return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' });
    }
    function short(d) {
      return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
    }
    function init(root) {
      (root || document).querySelectorAll('[data-e-stok]').forEach(function (el) {
        var i18nEl = el.parentElement.querySelector('[data-e-stok-i18n]');
        if (!i18nEl) return;
        var i18n = JSON.parse(i18nEl.textContent);
        var now = new Date();
        var cutoff = parseInt(el.dataset.cutoff, 10);
        var shipDays = parseInt(el.dataset.shipDays, 10);
        var weekend = now.getDay() === 0 || now.getDay() === 6;
        var beforeCutoff = !weekend && now.getHours() < cutoff;
        // Kesim saatinden önce verilen sipariş bugünden, sonra verilen yarından itibaren sayılır
        var start = beforeCutoff ? now : addBusinessDays(now, 1);
        var ship = shipDays > 1 ? addBusinessDays(start, shipDays - 1) : start;
        var dMin = addBusinessDays(ship, parseInt(el.dataset.minDays, 10));
        var dMax = addBusinessDays(ship, parseInt(el.dataset.maxDays, 10));
        var base = (beforeCutoff ? i18n.before : i18n.after)
          .replace('[saat]', String(cutoff).padStart(2, '0') + ':00')
          .replace('[tarih]', '<strong>' + fmt(ship) + '</strong>');
        var del = i18n.delivery.replace('[en_erken]', short(dMin)).replace('[en_gec]', short(dMax));
        el.querySelector('[data-e-ship-text]').innerHTML = base + ' ' + del;
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["elimest-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('e-set-slider')) {
    customElements.define(
      'e-set-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.e-pupsell__track');
          this.arrows = this.querySelectorAll('.e-pupsell__arrow');
          if (!this.track) return;
          this.arrows.forEach((btn) =>
            btn.addEventListener('click', () => {
              const card = this.track.querySelector('.e-pupsell__card');
              const step = card ? card.getBoundingClientRect().width + 10 : this.track.clientWidth * 0.8;
              this.track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
            })
          );
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
          this.update();
        }
        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }
        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.toggleAttribute('data-static', max <= 2);
          if (this.arrows[0]) this.arrows[0].disabled = t.scrollLeft <= 2;
          if (this.arrows[1]) this.arrows[1].disabled = t.scrollLeft >= max - 2;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
